import {YANDEX} from './by-brand/yandex'
import {YANDEXCOM} from './by-brand/yandexcom'
import {YANGO} from './by-brand/yango'

export const BY_BRAND = {
  yandex: YANDEX,
  yandexcom: YANDEXCOM,
  yango: YANGO,
}
